// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*------------------old--------------------*/    
.btn-outline-primary{
	color:#358696 ;
	border-color:#358696;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#358696;
	color:#fff;
}

.btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: #358696;
    border-color: #358696;
}
.btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: #358696;
    --bs-btn-border-color: #358696;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #358696;
    --bs-btn-hover-border-color: #358696;
    --bs-btn-focus-shadow-rgb: 49,132,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #358696;
    --bs-btn-active-border-color: #358696;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #358696;
    --bs-btn-disabled-border-color: #358696;
}

.form-check-input:checked {
    background-color: #358696;
    border-color: #358696;
}
.form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
}

/* Tabs Section */
.nav-link:focus, .nav-link:hover {
    /* color: var(--bs-nav-link-hover-color); */
	color: #358696;
}
.nav-link{
	color: #999;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #358696;
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color);
}

/* Section Header<> */

.secHead34 {
    background-color: #d3eff4;
    padding: 10px;
    margin-bottom: 20px;
}

.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}

.widget{
	background: #FFFFFF;
box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}
.widgetIcon img{
	width:50px;height:50px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.sec2Charts .titlebg {
    font-size: 1.1em;
    color: #000;
    font-weight: 500 ;
    margin-bottom: 10px;
	text-align: left;
}
.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
	text-align:center;
}
.chart3Title {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    text-align: left;
}
.chartboxPageOne_bus{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    min-height: 293px;
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}
.chartbox3{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
	 min-height:330px; 
}

	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}

.filterForm > .form-label{
	font-size:0.825em;
}

.form-label{
	font-size:0.825em;
    background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;

}
.Headfont{
	font-size:1.8rem;
}
.dropdown-menu[data-bs-popper] {
    right:0 !important;
	left: auto;
}

.logoTML{
	height:40px;
}

.boxHead_bus{
	background: #CDDAEA;
	border-bottom: 1px solid #8e3596;
	padding:5px;
	height:30px;
	margin-bottom: 15px;
}
.boxHeadText{
	font-size:0.825em;
	font-weight:bold;
	color:#222;
}


.tableHold table thead{
	width: 100%;
}
.tableHold table thead tr{
	display:block;
}
.tableHold table tbody{
	display:block;
	width: 100%;
	height: 150px;
	overflow-y:scroll;
}
.tableHold table tbody tr{display:block;
}

/******* Table Content Page One *******/
.fixed_header{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}

.fixed_header tbody{
  display:block;
  width: 100%;
  overflow: auto;
  height: 186px;
}

.fixed_header thead tr {
   display: block;
}

.fixed_header thead {
  background: black;
  color:#fff;
}

.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}
	
/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}

.icon-rgt {
    /* width: 62%; */
    float: right;
}
.icon-rgt-top {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 2px 0px;
}
.fst1 {
    border-left: solid 2px #ffa650;
    float: right;
    margin-right: 10px;
    padding-left: 5px;
    font-size: 11px;
}
.icon-rgt-top {
}
.fst {
    border-left: solid 2px #ffa650;
    padding-left: 5px;
    font-size: 11px;
}



/* media queries start here */

@media screen and (max-width: 1024px) {
.logoTML{
  height: 25px;
}
}

@media screen and (max-width: 1000px) {
.fixed_header tbody{
  height: 150px;
}
}

@media screen and (max-width: 991px) {
.mgt-2{margin-top:20px;}
}

@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}

@media screen and (max-width: 720px) {
.mainDiv{
	margin-top:124px;
}
}

@media screen and (max-width: 480px) {
.mainDiv{
	margin-top:145px;
}
}

@media screen and (max-width: 375px) {
.mainDiv{
	margin-top:155px;
}
}
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}
.hand_geture:hover{
    color: blue;
}
.hand_geture {
    cursor: pointer !important;
}
.select_col_title {
	background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;
  }
  .text-mutedf{
    font-size:1em !important;
  }
  .titlebg_bus_fault {
    font-size: 1em;
    color: #0E3157;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
    border-radius: 5px 5px 0 0;
    margin-top: -12px;
    margin-left: -10px;
    margin-right: -10px;
}

`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/Faultanalysis_BusNew/FaultFirstPage/FaultFirstPageCustom_bus.css"],"names":[],"mappings":";AACA,4CAA4C;AAC5C;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,qCAAqC;IACrC,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,4DAA4D;IAC5D,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,+CAA+C;AACnD;;AAEA,iBAAiB;AACjB;IACI,2CAA2C;CAC9C,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;IACI,cAAc;IACd,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB,4CAA4C;AAC5C;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;CACtB,gBAAgB;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;CACtB,iBAAiB;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;EAChB,gBAAgB;AAClB;;CAEC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;IACd,uBAAuB;CAC1B,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;;AAEf;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,WAAW;CACX,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;AACX;;;AAGA;CACC,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,WAAW;CACX,aAAa;CACb,iBAAiB;AAClB;AACA,0BAA0B,aAAa;AACvC;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;GACG,cAAc;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;AACA;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;AACnB;;;;AAIA,6BAA6B;;AAE7B;AACA;EACE,YAAY;AACd;AACA;;AAEA;AACA;EACE,aAAa;AACf;AACA;;AAEA;AACA,OAAO,eAAe,CAAC;AACvB;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;EACb;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":["\n/*------------------old--------------------*/    \n.btn-outline-primary{\n\tcolor:#358696 ;\n\tborder-color:#358696;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\tbackground-color:#358696;\n\tcolor:#fff;\n}\n\n.btn:hover {\n    color: var(--bs-btn-hover-color);\n    background-color: #358696;\n    border-color: #358696;\n}\n.btn-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #358696;\n    --bs-btn-border-color: #358696;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #358696;\n    --bs-btn-hover-border-color: #358696;\n    --bs-btn-focus-shadow-rgb: 49,132,253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #358696;\n    --bs-btn-active-border-color: #358696;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #358696;\n    --bs-btn-disabled-border-color: #358696;\n}\n\n.form-check-input:checked {\n    background-color: #358696;\n    border-color: #358696;\n}\n.form-select:focus {\n    border-color: #358696;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\n}\n\n/* Tabs Section */\n.nav-link:focus, .nav-link:hover {\n    /* color: var(--bs-nav-link-hover-color); */\n\tcolor: #358696;\n}\n.nav-link{\n\tcolor: #999;\n}\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n    color: #358696;\n    background-color: var(--bs-nav-tabs-link-active-bg);\n    border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n\n/* Section Header<> */\n\n.secHead34 {\n    background-color: #d3eff4;\n    padding: 10px;\n    margin-bottom: 20px;\n}\n\n.bg-white{\n\tbackground-color:#fff;\n}\n.headBG {\nbox-sizing: border-box;\nbackground: #FFFFFF;\nborder: 1px solid #358696;\n}\n\n.mainDiv{\n\tmargin-top:80px;\n}\n\n.widget{\n\tbackground: #FFFFFF;\nbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n}\n.widgetIcon img{\n\twidth:50px;height:50px;\n}\n.widgetIcon-32 img{\n\twidth:32px;height:32px;\n}\n.sec2Charts .titlebg {\n    font-size: 1.1em;\n    color: #000;\n    font-weight: 500 ;\n    margin-bottom: 10px;\n\ttext-align: left;\n}\n.titlebg {\n    font-size: 1.2em;\n    color: #000;\n    font-weight: 500;\n    margin-bottom: 10px;\n\ttext-align:center;\n}\n.chart3Title {\n    font-size: 1.2em;\n    color: #000;\n    font-weight: 500;\n    text-align: left;\n}\n.chartboxPageOne_bus{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    min-height: 293px;\n}\n.chartbox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* font-size: 14px; */\n}\n.chartbox3{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n\t min-height:330px; \n}\n\n\th5, .h5 {\n    font-size: 1.1rem !important;\n}\np {\n    line-height: 1rem !important;\n}\nsmall, .small {\n    font-size: 80% !important;\n}\n\t\ntable tr td {\n\tfont-size:0.8em;\n}\n.accordion-button{\n\tfont-size:0.5em;\n}\n.accordion-button:not(.collapsed){\n\tbackground-color:#e0e0e0;\n\tcolor:#222;\n}\n\n.filterForm > .form-label{\n\tfont-size:0.825em;\n}\n\n.form-label{\n\tfont-size:0.825em;\n    background: transparent; \n\tpadding: 0px !important;\n\ttext-align: left;\n\t margin-bottom:0px !important;\n\tcolor: #358696 !important;\n\tfont-weight: 600;\n\tdisplay: block;\n\n}\n.Headfont{\n\tfont-size:1.8rem;\n}\n.dropdown-menu[data-bs-popper] {\n    right:0 !important;\n\tleft: auto;\n}\n\n.logoTML{\n\theight:40px;\n}\n\n.boxHead_bus{\n\tbackground: #CDDAEA;\n\tborder-bottom: 1px solid #8e3596;\n\tpadding:5px;\n\theight:30px;\n\tmargin-bottom: 15px;\n}\n.boxHeadText{\n\tfont-size:0.825em;\n\tfont-weight:bold;\n\tcolor:#222;\n}\n\n\n.tableHold table thead{\n\twidth: 100%;\n}\n.tableHold table thead tr{\n\tdisplay:block;\n}\n.tableHold table tbody{\n\tdisplay:block;\n\twidth: 100%;\n\theight: 150px;\n\toverflow-y:scroll;\n}\n.tableHold table tbody tr{display:block;\n}\n\n/******* Table Content Page One *******/\n.fixed_header{\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: collapse;\n}\n\n.fixed_header tbody{\n  display:block;\n  width: 100%;\n  overflow: auto;\n  height: 186px;\n}\n\n.fixed_header thead tr {\n   display: block;\n}\n\n.fixed_header thead {\n  background: black;\n  color:#fff;\n}\n\n.fixed_header th, .fixed_header td {\n  padding: 5px;\n  text-align: left;\n  width: 200px;\n}\n\t\n/***************************** PageTwo *******************************/\n.bt-graph {\n    border-right: solid 1px #b5b5b5;\n}\n\n.icon-rgt {\n    /* width: 62%; */\n    float: right;\n}\n.icon-rgt-top {\n    font-size: 13px;\n    width: 100%;\n    padding: 5px 0px 2px 0px;\n}\n.fst1 {\n    border-left: solid 2px #ffa650;\n    float: right;\n    margin-right: 10px;\n    padding-left: 5px;\n    font-size: 11px;\n}\n.icon-rgt-top {\n}\n.fst {\n    border-left: solid 2px #ffa650;\n    padding-left: 5px;\n    font-size: 11px;\n}\n\n\n\n/* media queries start here */\n\n@media screen and (max-width: 1024px) {\n.logoTML{\n  height: 25px;\n}\n}\n\n@media screen and (max-width: 1000px) {\n.fixed_header tbody{\n  height: 150px;\n}\n}\n\n@media screen and (max-width: 991px) {\n.mgt-2{margin-top:20px;}\n}\n\n@media screen and (max-width: 740px) {\n.titlebg {\n\tfont-size: 0.9em;\n}\n}\n\n@media screen and (max-width: 720px) {\n.mainDiv{\n\tmargin-top:124px;\n}\n}\n\n@media screen and (max-width: 480px) {\n.mainDiv{\n\tmargin-top:145px;\n}\n}\n\n@media screen and (max-width: 375px) {\n.mainDiv{\n\tmargin-top:155px;\n}\n}\n\t\n@media screen and (max-width: 480px) {\n.topHeader h2{\n\tfont-size: 22px;\n    padding-right: 3rem;\n}\n\t.titlebg {\n\t\tfont-size: 0.9em;\n\t}\n}\n\n@media screen and (max-width: 320px) {\n\t.topHeader h2{\n\tfont-size: 16px;\n\t\tpadding-right: 0rem;\n\t}\n}\n.hand_geture:hover{\n    color: blue;\n}\n.hand_geture {\n    cursor: pointer !important;\n}\n.select_col_title {\n\tbackground: transparent; \n\tpadding: 0px !important;\n\ttext-align: left;\n\t margin-bottom:0px !important;\n\tcolor: #358696 !important;\n\tfont-weight: 600;\n\tdisplay: block;\n  }\n  .text-mutedf{\n    font-size:1em !important;\n  }\n  .titlebg_bus_fault {\n    font-size: 1em;\n    color: #0E3157;\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n    border-radius: 5px 5px 0 0;\n    margin-top: -12px;\n    margin-left: -10px;\n    margin-right: -10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
